import bouncyLarge from "@/assets/p-bouncy-large.jpg";
import obstacle from "@/assets/p-obstacle.jpg";
import sumo from "@/assets/p-sumo.jpg";
import slide from "@/assets/p-slide.jpg";
import wheel from "@/assets/p-wheel.jpg";
import fish from "@/assets/p-fish.jpg";
import airhockey from "@/assets/p-airhockey.jpg";
import boxer from "@/assets/p-boxer.jpg";
import basket from "@/assets/p-basket.jpg";
import darts from "@/assets/p-darts.jpg";
import pa from "@/assets/p-pa.jpg";
import mic from "@/assets/p-mic.jpg";
import stage from "@/assets/p-stage.jpg";
import light from "@/assets/p-light.jpg";
import smoke from "@/assets/p-smoke.jpg";
import placeholder from "@/assets/p-bouncy-large.jpg";

const PRODUCT_IMAGE_MAP: Record<string, string> = {
  "p-bouncy-large.jpg": bouncyLarge,
  "p-obstacle.jpg": obstacle,
  "p-sumo.jpg": sumo,
  "p-slide.jpg": slide,
  "p-wheel.jpg": wheel,
  "p-fish.jpg": fish,
  "p-airhockey.jpg": airhockey,
  "p-boxer.jpg": boxer,
  "p-basket.jpg": basket,
  "p-darts.jpg": darts,
  "p-pa.jpg": pa,
  "p-mic.jpg": mic,
  "p-stage.jpg": stage,
  "p-light.jpg": light,
  "p-smoke.jpg": smoke,
};

export function resolveImage(image: string | null | undefined): string {
  if (!image) return placeholder;
  if (image.startsWith("http://") || image.startsWith("https://") || image.startsWith("/")) {
    return image;
  }
  return PRODUCT_IMAGE_MAP[image] ?? placeholder;
}

/**
 * If `src` points at a Supabase Storage public object, rewrite to the
 * image-render endpoint with the requested width + quality. WebP is
 * negotiated automatically. Otherwise return src unchanged.
 */
export function transformedSupabaseImage(src: string, width: number, quality = 70): string {
  const marker = "/storage/v1/object/public/";
  const i = src.indexOf(marker);
  if (i === -1) return src;
  const base = src.slice(0, i);
  const rest = src.slice(i + marker.length);
  return `${base}/storage/v1/render/image/public/${rest}?width=${width}&quality=${quality}&resize=contain`;
}

/**
 * Build srcSet + fallback src for a Supabase-hosted product image.
 * Non-Supabase URLs (bundled assets, /assets/... paths) return just `src`.
 */
export function productImageSrcSet(src: string): { src: string; srcSet?: string; sizes?: string } {
  if (!src.includes("/storage/v1/object/public/")) {
    return { src };
  }
  const widths = [400, 800, 1200];
  const srcSet = widths.map((w) => `${transformedSupabaseImage(src, w)} ${w}w`).join(", ");
  return {
    src: transformedSupabaseImage(src, 800),
    srcSet,
    sizes: "(min-width: 1024px) 25vw, (min-width: 640px) 33vw, 50vw",
  };
}

